import { render, staticRenderFns } from "./CardExpand.vue?vue&type=template&id=59d08948&scoped=true"
import script from "./CardExpand.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardExpand.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CardExpand.vue?vue&type=style&index=0&id=59d08948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d08948",
  null
  
)

export default component.exports